import { typeDetailsForm, typeForm } from "../../pages/ContractRegist"
import { GetHeader, PPHeader } from "../common"


const URL = process.env.REACT_APP_API_KEIYAKU!

export interface typeContractItemList {
  keiyakuNo: string,
  keiyakuClsCd: string,
  keiyakuClsName: string,
  incidentCount: number | null,
  incidentAddCount: number | null,
  incidentUsedCount: number | null,
  keiyakuClsNotes: string | null,
}

export interface typeBasicInfo {
  keiyakuNo: string,
  orderNo: string | null,
  custmNo: string,
  keiyakuStartTs: string | null,
  keiyakuClsCd: string | null,
  keiyakuDeposit: number | null,
  payClsCd: string | null,
  keiyakuOption: string | null,
  visitCount: number | null,
  keiyakuPersonCd: string | null,
  salesPersonCd: string | null,
  salesDeptCd: string | null,
  keiyakuNote: string | null,
  demandZipCd: string | null,
  demandAddress: string | null,
  demandCompanyName: string | null,
  demandDeptName: string | null,
  demandPostName: string | null,
  demandPersonName: string | null,
  totalPrice: number | null,
  monthlyPrice: number | null,
  actionSeDeptCd: string | null,
  demandNote: string | null,
  createDate: string | null,
  createCd: string | null,
  updateDate: string | null,
  updateCd: string | null,
  custmDepNo: string | null,
  kaiyakuTs: string | null,
  machineSettingZipCd: string | null,
  machineSettingAddress: string | null,
  incidentDeposit: number | null,
  incidentCount: number | null,
  incidentAddCount: null | null,
  incidentUsedCount: number | null,
  monthlyPrice2: number | null,
  custmName: string,
  keiyakuClsName: string | null,
  keiyakuClsNotes: string | null,
  payClsName: string | null,
  keiyakuPersonName: string | null,
  keiyakuPersonTel: string | null,
  keiyakuPersonEmail: string | null,
  keiyakuPersonDeptName: string | null,
  salesPersonName: string | null,
  mailClsCd: string | null,
  renewalMonth: string | null,
}

export interface typeContractList {
  keiyakuClsCd: string,
  keiyakuClsName: string,
  keiyakuClsNotes: string,
}

export interface typeDetailsInfo {
  keiyakuNo: string,
  keiyakuDetailNo: string,
  hwType: string | null,
  hwSerial: string | null,
  swOs: string | null,
  swApl: string | null,
  hwHoshu: string | null,
  createDate: Date | null,
  createCd: string | null,
  updateDate: Date | null,
  updateCd: string | null,
  virtualEnvflag: string | null,
  virtualOs: string | null,
  virtualApl: string | null,
  keiyakuNote: string | null,
}

export interface typeCisUserList {
  userCd: string,
  termCd: string,
  startDate: string | null,
  endDate: string | null,
  telephoneNumber: string | null,
  mobileNumber: string | null,
  faxNumber: string | null,
  extensionNumber: string | null,
  extensionFaxNumber: string | null,
  countryCd: string | null,
  zipCode: string | null,
  emailAddress1: string | null,
  emailAddress2: string | null,
  mobileEmailAddress: string | null,
  url: string | null,
  localeId: string | null,
  userName: string,
  userNameSyllabary: string | null,
  userNameEng: string | null,
  address: string | null,
  companyCd: string,
  departmentCd: string | null,
  departmentName: string | null,
  departmentNameSyllabary: string | null,
  departmentNameEng: string | null,
  address1: string | null,
  address2: string | null,
  notes: string | null,
}

export interface typeCisDepartmentList {
  companyCd: string,
  departmentCd: string,
  departmentName: string,
  departmentNameSyllabary: string | null,
  departmentNameEng: string | null,
  address1: string | null,
  address2: string | null,
}

interface typeGetContract {
  keiyakuBt: typeForm,
  keiyakuDt: typeDetailsForm[]
}

//012 契約項目一覧取得
export const getContractItemList = async (userid: string, tokenUser: string, token: string, role: string): Promise<typeContractItemList[]> => {
  const header = GetHeader(tokenUser, token, role)
  const res = await fetch(`${URL}/keiyakuclss/${userid}`, header).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//013 契約一覧取得
export const getContractList = async (userid: string, tokenUser: string, token: string, role: string, keiyakuclscd: string, salespersoncd: string, renewalmonth: string, demandmonth: string): Promise<typeContractList[]> => {
  const params = new URLSearchParams()
  params.set('userId', userid)
  params.set('keiyakuClsCd', keiyakuclscd)
  params.set('salesPersonCd', salespersoncd)
  params.set('renewalMonth', renewalmonth)
  params.set('demandMonth', demandmonth)
  const header = GetHeader(tokenUser, token, role)
  const res = await fetch(`${URL}/keiyakus?${params.toString()}`, header).then(response => {
    if (response.status === 204) {
      return []
    } else if (response.ok) {//データが存在する
      return response.json()
    } else {
      throw response
    }
  }).then(res => {
    for (const reso of res) {
      for (const [key, value] of Object.entries(reso)) {//日付フィールドDate型変換
        if (key === 'keiyakuStartTs' || key === 'createDate' || key === 'updateDate' || key === 'kaiyakuTs') {
          if (value && typeof value === 'string') {
            reso[key] = new Date(value)
          }
        } else if (key === 'renewalMonth') {//更新月13(解約)の場合は更新月ブランク表示
          if (value && value === '13') {
            reso[key] = ''
          }
        }
      }
    }
    return res
  })
  return res
}

//014 契約基本情報取得
export const getBasicInfo = async (userid: string, token: string, role: string, keiyakuno: string): Promise<typeBasicInfo> => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/keiyakubt/${keiyakuno}`, header).then(response => {
    if (response.status === 204) {
      return null
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  }).then(res => {
    if (res) {
      for (const [key, value] of Object.entries(res)) {//日付フィールドDate型変換
        if (key === 'keiyakuStartTs' || key === 'createDate' || key === 'updateDate' || key === 'kaiyakuTs') {
          if (value && typeof value === 'string') {
            res[key] = new Date(value)
          }
        }
      }
    }
    return res
  })
  return res
}


//015 契約詳細情報取得
export const getDetailsInfo = async (userid: string, token: string, role: string, keiyakuno: string) => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/keiyakudt/${keiyakuno}`, header).then(response => {
    if (response.status === 204) {
      return null
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  }).then(res => {
    if (res) {
      for (const reso of res) {
        for (const [key, value] of Object.entries(reso)) {//日付フィールドDate型変換
          if (key === 'createDate' || key === 'updateDate') {
            if (value && typeof value === 'string') {
              reso[key] = new Date(value)
            }
          }
          if (key === 'virtualEnvflag') {
            if (value === '1') {
              reso[key] = true
            } else {
              reso[key] = false
            }
          }
        }
      }
    }
    return res
  })
  return res
}

//034 契約項目一覧取得サービス(全取得)
export const getAllContractList = async (userid: string, token: string, role: string): Promise<typeContractList[]> => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/keiyakuclss`, header).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}


//037 担当営業取得サービス(CIS全社員)
export const getCisUserList = async (userid: string, token: string, role: string, keyword: string): Promise<typeCisUserList[]> => {
  const params = new URLSearchParams()
  params.set('keyWord', keyword)
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/sales?${params.toString()}`, header).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}


//038 契約情報取得
export const getContract = async (userid: string, token: string, role: string, keiyakuno: string) => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/keiyaku/${keiyakuno}`, header).then(response => {
    if (response.status === 204) {
      return null
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  }).then(res => {
    if (res) {
      let resBtObject = {}
      let resDtList = []
      if (res.keiyakuBt) {
        for (const [key, value] of Object.entries(res.keiyakuBt)) {//日付フィールドDate型変換
          if (key === 'createDate' || key === 'updateDate' || key === 'keiyakuStartTs' || key === 'kaiyakuTs') {
            if (value && typeof value === 'string') {
              resBtObject[key] = new Date(value)
            }
          } else if (key === 'renewalMonth' || key === 'demandMonth') {
            if (value && typeof (value) === 'string') {
              resBtObject[key] = value.split(',').map(value => Number(value))
            } else {
              resBtObject[key] = []
            }
          } else if (key === 'orderNo' || key === 'keiyakuNo') {
            if (value && typeof value === 'string') {
              resBtObject[key] = value.replace(/\s/g, '')
            }
          } else if (key === 'monthlyPrice' || key === 'visitCount' || key === 'monthlyPrice' || key === 'incidentDeposit' || key === 'incidentCount' || key === 'incidentAddCount' || key === 'monthlyPrice2' || key === 'keiyakuDeposit' || key === 'totalPrice') {
            if (value === 0) {
              resBtObject[key] = '0'
            } else if (value && typeof (value) === 'number') {
              resBtObject[key] = String(value)
            } else if (!value) {
              resBtObject[key] = ''
            }
          } else {
            resBtObject[key] = value
          }
        }
      }
      if (res.keiyakuDt) {
        for (const reso of res.keiyakuDt) {
          let resDtObj = {}
          for (const [key, value] of Object.entries(reso)) {//日付フィールドDate型変換
            if (key === 'createDate' || key === 'updateDate') {
              if (value && typeof value === 'string') {
                resDtObj[key] = new Date(value)
              }
            } else if (key === 'virtualEnvflag') {
              if (value === '1') {
                resDtObj[key] = true
              } else {
                resDtObj[key] = false
              }
            } else {
              resDtObj[key] = value
            }
          }
          resDtList.push(resDtObj)
        }
      }
      return {
        keiyakuBt: resBtObject,
        keiyakuDt: resDtList
      }
    }
    return res
  })
  return res
}


//039 担当SE部門取得サービス
export const getCisDepartmentList = async (userid: string, token: string, role: string): Promise<typeCisDepartmentList[]> => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/sedept`, header).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//040 契約新規登録
export const postContract = async (userid: string, token: string, role: string, form: typeForm, detailsform: typeDetailsForm[]) => {
  let sendform = {}//結合先
  //form to JSON
  let formobj = {}//基本,請求
  for (const [key, value] of Object.entries(form)) {
    if (value || value === 0) {
      if (key === 'renewalMonth' || key === 'demandMonth') {
        formobj[key] = value.join()
      } else if (key === 'keiyakuNote' || key === 'demandNote' || key === 'keiyakuOption') {
        formobj[key] = value.replace(/(\r\n|\n|\r)+$/, '').replace(/(\r\n|\n|\r)/g, '\r\n')
      } else {
        formobj[key] = value
      }
    }
  }
  let detailsList = []//詳細
  for (const details of detailsform) {
    let detailsObj = {}
    for (const [key, value] of Object.entries(details)) {
      if (key === 'virtualEnvflag') {
        if (value) {
          detailsObj[key] = '1'
        } else {
          detailsObj[key] = '0'
        }
      } else {
        detailsObj[key] = value
      }
    }
    detailsList.push(detailsObj)
  }
  sendform['keiyakuBt'] = formobj
  sendform['keiyakuDt'] = detailsList
  const jsondata = JSON.stringify(sendform)
  const header = PPHeader(userid, token, role, jsondata, 'POST')
  const res = await fetch(`${URL}/keiyaku`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else if (response.status === 400) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//041 契約更新
export const putContract = async (userid: string, token: string, role: string, form: typeForm, detailsform: typeDetailsForm[]) => {
  let sendform = {}//結合先
  //form to JSON
  let formobj = {}//基本,請求
  for (const [key, value] of Object.entries(form)) {
    if (value || value === 0) {
      if (key === 'renewalMonth' || key === 'demandMonth') {
        formobj[key] = value.join()
      } else if (key === 'keiyakuNote' || key === 'demandNote' || key === 'keiyakuOption') {
        formobj[key] = value.replace(/(\r\n|\n|\r)+$/, '').replace(/(\r\n|\n|\r)/g, '\r\n')
      } else {
        formobj[key] = value
      }
    }
  }
  let detailsList = []//詳細
  for (const details of detailsform) {
    let detailsObj = {}
    for (const [key, value] of Object.entries(details)) {
      if (key === 'virtualEnvflag') {
        if (value) {
          detailsObj[key] = '1'
        } else {
          detailsObj[key] = '0'
        }
      } else {
        detailsObj[key] = value
      }
    }
    detailsList.push(detailsObj)
  }
  sendform['keiyakuBt'] = formobj
  sendform['keiyakuDt'] = detailsList
  const jsondata = JSON.stringify(sendform)
  const header = PPHeader(userid, token, role, jsondata, 'PUT')
  const res = await fetch(`${URL}/keiyaku/${form.keiyakuNo}`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else {
      throw response
    }
  })
  return res
}